import { render, staticRenderFns } from "./receivers.vue?vue&type=template&id=9beb662c&scoped=true"
import script from "./receivers.vue?vue&type=script&lang=js"
export * from "./receivers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9beb662c",
  null
  
)

export default component.exports